import * as Yup from "yup";
import { FormGroup } from "../../components/form";
import { RoleId } from "../enums/Role";

export const InviteUserForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "my-3 text-purple font-bold",
      },
      label: "Invite a user to join this KIS Provider",
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "mb-0",
      },
      label: "Enter the email address of the KIS Provider user that you wish to invite",
    },
    {
      type: "field",
      key: "userEmail",
      fieldType: "input",
      props: {
        className: "mb-0",
      },
      label: "Email",
      validation: Yup.string()
        .required("A response is required")
        .matches(RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[.][a-zA-Z]{2,}$"), { message: "Please enter a valid email address" }),
    },
    {
      type: "component",
      body: () => <></>,
      defaultValue: {
        roleType: RoleId.Provider,
        inviteRedirectUrl: import.meta.env.VITE_POSTLOGOUTREDIRECTURI,
        userLinkDiscriminator: 1,
        authorisationLevel: 0,
      },
    },
    {
      type: "field",
      key: "providerName",
      fieldType: "value",
      calculatedValue: (context) => context.providerName,
    },
  ],
};
